import PropTypes from 'prop-types'
import useStyles from './styles'
import VisitModalityIcon from 'components/Dashboard/cards/common/VisitModalityIcon'
import ChevronDownIcon from '@ui-components-3/icons/lib/solid/ChevronDown'
import ChevronUpIcon from '@ui-components-3/icons/lib/solid/ChevronUp'

const MODALITY_LABELS = {
  phone: 'Phone Visit',
  video: 'Video Visit',
  chat: 'Chat Visit',
  successphone: 'Phone Session',
  successvideo: 'Video Session',
}

const DefaultImageBlock = ({ modality, handleArrowClick, isMobile, memberPanelVisible, isSuccess }) => {
  const classes = useStyles()

  if (!modality) return null

  const labelPrefix = isSuccess ? `success` : ''

  const ArrowIcon = memberPanelVisible ? ChevronUpIcon : ChevronDownIcon

  return (
    <div className={classes.defaultImageContainer}>
      <VisitModalityIcon modality={modality} className="text-secondary-700" />

      <h3 className="typography-body md:typography-body-xl font-semibold text-secondary-700 text-center whitespace-nowrap ml-2 xl:ml-3">
        {MODALITY_LABELS[`${labelPrefix}${modality}`]}
      </h3>
      {isMobile && (
        <button
          type="button"
          className="absolute top-0 right-0 btn-md btn-secondary-borderless"
          aria-label={`${memberPanelVisible ? 'Hide' : 'Show'} member info`}
        >
          <ArrowIcon aria-hidden="true" onClick={handleArrowClick} />
        </button>
      )}
    </div>
  )
}

DefaultImageBlock.propTypes = {
  modality: PropTypes.oneOf(['phone', 'video', 'text', 'chat']).isRequired,
  handleArrowClick: PropTypes.func,
  isMobile: PropTypes.bool,
  memberPanelVisible: PropTypes.bool,
}

export default DefaultImageBlock
